import React from "react";
import { useParams, withRouter } from "react-router-dom";
import { css } from "emotion";
import { boxStyles, colors } from "../../styles/theme";
import plans from "../plans/data/plans";

const PlanCards = ({showDiscount, currentPlan, history}) => {
  const { planId: desiredPlan } = useParams();
  const { name, price, features } = plans.filter(
    (plan) => plan.id === desiredPlan
  )[0];
  const coupon = sessionStorage.getItem('coupon');

  if (desiredPlan === currentPlan) {
    history.push('/plans');
  }

  return (
    <div className={container}>
      <div className="top-row">
        <h4>{name.toUpperCase()}</h4>
      </div>
      <div className="features">
        <ul>
          {features.map((feature, i) => (
            <li key={`feature-${i}`}>{feature}</li>
          ))}
        </ul>
      </div>
      <p className="price">{<span>{coupon && showDiscount ? (price  * .5).toFixed(2) : price}</span>}/ mo</p>
    </div>
  );
};

export default withRouter(PlanCards);

const container = css`
  margin-bottom: 30px;
  padding: 15px;
  box-shadow: ${boxStyles.boxShadow};
  border-radius: ${boxStyles.borderRadius};
  position: relative;
  min-width: 290px;
  transition-duration: 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h4 {
      font-size: 24px;
      letter-spacing: 1px;
    }
  }

  .features {
    ul {
      padding-left: 30px;
      list-style: none;
      font-size: 14px;
      color: ${colors.subtitleColor};

      li {
        position: relative;
        margin-top: 8px;

        &::before {
          content: "✓";
          display: block;
          position: absolute;
          background-color: ${colors.brandColor};
          color: white;
          height: 18px;
          width: 18px;
          border-radius: 50%;
          left: -30px;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          text-align: center;
        }
      }
    }
  }

  .price {
    position: absolute;
    bottom: 5px;
    right: 15px;
    font-size: 14px;
    font-weight: bold;

    span {
      font-size: 36px;
    }
  }
`;
